(function () {
  function initParallaxBanner(section) {
    var media = section.querySelector('[data-parallax-banner-media]');
    var viewport = section.querySelector('.parallax-banner__viewport');
    var rafId = 0;

    if (!media || !viewport) return;
    if (section.dataset.parallaxBannerReady === 'true') return;
    section.dataset.parallaxBannerReady = 'true';

    function getStrength() {
      var styles = window.getComputedStyle(section);
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      var value = mobile
        ? styles.getPropertyValue('--parallax-banner-strength-mobile')
        : styles.getPropertyValue('--parallax-banner-strength-desktop');

      return parseFloat(value) || 0;
    }

    function update() {
      var rect = section.getBoundingClientRect();
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      var progress = ((rect.top + rect.height) / (windowHeight + rect.height)) - 0.5;
      var strength = getStrength();
      var translateY = progress * strength * rect.height;

      media.style.transform = 'translate3d(0,' + translateY.toFixed(2) + 'px,0)';
      rafId = 0;
    }

    function requestUpdate() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(update);
    }

    requestUpdate();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    section.addEventListener('shopify:section:unload', function () {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
      }
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
    }, { once: true });
  }

  document.querySelectorAll('[data-parallax-banner]').forEach(initParallaxBanner);
})();
